import { afterNextPaint } from './afterNextPaint';

window.addEventListener('DOMContentLoaded', () => {
  // A live region (explicit `aria-live` or implicit via `role="alert/status"`) only announces content that
  // changes AFTER assistive tech has registered it. Server-rendered regions are already populated at
  // load, so they would never announce. The spec-compliant fix is to render the region EMPTY with its
  // payload in an inert `<template>`, then move the payload in once the empty region has painted — a
  // genuine insertion the screen reader announces. Opt in from ERB via the `announce_on_load` helper
  // (it emits `data-announce-on-load` + the template).
  // NOTE: Applies to ERB rendered content ONLY; Vue component markup reinjected in this way would disconnect Vue reactivity.
  // @see (author is a field expert) https://cerovac.com/a11y/2023/08/status-messages-on-page-load-how-to-notify-screen-reader-users-about-important-messages-when-the-page-loads/
  // @see https://github.com/w3c/aria/issues/1360
  afterNextPaint(() => {
    document.querySelectorAll('[data-announce-on-load]').forEach($region => {
      const $template = $region.querySelector(':scope > template') as HTMLTemplateElement | null;
      if ($template) {
        $region.appendChild($template.content.cloneNode(true));
      }
    });
  });
});